var loading_bars = `<img height="20" src=${RAILS_ASSET_URL('bars.svg')} class="loading" alt="Bars">`;

export function remote_script_request(event) {
  event.preventDefault();

  var target = $($(this).data('target'))

  if (target.length === 0)
    target = $(this).parent();

  target.html(loading_bars);

  $.ajax({
    url: $(this).data('url'),
    method: 'POST',
    dataType: 'script',
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
    }
  });
}
